import {
  alert_check,
  cash_file,
  chat_bubble,
  cloud_data,
  file_text,
  interface_user_multiple,
  utility
} from "../svg/svgs.js";
import { defineNavigation } from "./navigation.definer";

export function useNavigation(isNotaio = false, features, device = 'desktop') {
  let navigationObj= {};
  let isCittadino = !isNotaio;

  switch (device) {
    case 'desktop':
      navigationObj = {
        /*dashboard: defineNavigation(home, "Home", "/dashboard", isNotaio, false, !(features['crm_full'])),*/
        pratiche: defineNavigation(cloud_data, "Pratiche", "/pratiche", true, false, (!isCittadino && features['crm_light']), "pratiche", ['pratica']),
        documenti: defineNavigation(file_text, "Lista documenti", "/documenti", true, false, (!isCittadino && features['crm_light'])),
        rubrica_soggetti: defineNavigation(interface_user_multiple, "Rubrica soggetti", "/rubrica_soggetti", isNotaio, false, !(features['crm_full']), "rubrica_soggetti", ['rubrica_soggetto']),
        questionari: defineNavigation(alert_check, "Checklist", "/questionari", isNotaio, false, !(features['crm_full'])),
        preventivi: {
          ...defineNavigation(cash_file, "Preventivatore ed equo compenso", null, isNotaio, false),
          children: [
            defineNavigation(null, "Calcolatore", "/preventivi", isNotaio, false, false, "preventivi"),
            defineNavigation(null, "Storico", "/storico_preventivi", isNotaio, false, false, "storico_preventivi")
          ]
        },
        utilita: defineNavigation(utility, "Utilità", "/utilita", isNotaio, false, false),
        messaggi: defineNavigation(chat_bubble, "Messaggi", "/messaggi", false, false, true)
      };
      break;
  }
  return navigationObj;
}